diy.angular.registerFactory('diyfminsertprogress', [function() {

    var show = false,
        currentFiles,
        totalFiles;

    return {
        progressConfig: {
            getter: function() {
                if ('number' !== typeof currentFiles || 'number' !== typeof totalFiles) {
                    return 0;
                }
                var progress = currentFiles / totalFiles;
                return progress;
            },
            runOnce: false,
            onFinish: function() { }
        },
        setProgress: function(_currentFiles, _totalFiles) {
            currentFiles = _currentFiles;
            totalFiles = _totalFiles;
        },
        getProgressString: function() {
            return currentFiles + ' / ' + totalFiles;
        },
        isShown: function() {
            return show;
        },
        show: function() {
            show = true;
        },
        hide: function() {
            show = false;
            var $dialogEl = jQuery('.fm-dialog');
            $dialogEl.find('.fm-insert-polaroid').remove();
        },
        showLoadingImage: function(imageUrl) {
            // get the dialog and the insert mask
            var $dialogEl = jQuery('.fm-dialog');
            var $mask = $dialogEl.find('.fm-insert-mask');

            // get the dialog dimensions
            var dialogWidth = $dialogEl.width();
            var dialogHeight = $dialogEl.height();

            // create the image that will be displayed while adding
            var $img = jQuery('<div class="fm-insert-polaroid"><span></span></div>');

            // set the source
            $img.find('span').css('background-image', 'url(' + imageUrl + ')');

            /*
             start delayed, so we get a chance to get the image loaded
             the reason we don't bind on the load event is because some pictures
             are already loaded and the load event won't trigger
             */
            setTimeout(function() {
                // yes, synchronous, load event sometimes does not trigger,
                // espacially if there are already images (which happens)
                $img.appendTo($mask);
                // calculate the top and left coordinates to place the image
                var top = dialogHeight / 2 - $img.height() / 2;
                var left = -$img.width();

                // calculate the center
                var centerLeft = dialogWidth / 2 - $img.width() / 2;

                // compute a random degree angle tilt between -5 and 5
                var max = 5, min = -5;
                var rotate = Math.random() * (max - min) + min;
                $img.css({
                    left: left,
                    top: top,
                    '-webkit-transform': 'rotate(' + rotate + 'deg)',
                    '-moz-transform': 'rotate(' + rotate + 'deg)',
                    '-ms-transform': 'rotate(' + rotate + 'deg)',
                    'transform': 'rotate(' + rotate + 'deg)'
                }).animate({
                    left: centerLeft
                }, 400, function() {
                    // clear the previous polaroids
                    var $polaroids = $dialogEl.find('.fm-insert-polaroid');
                    if ($polaroids.length > 5) {
                        $polaroids.eq(0).hide(200, function() {
                            jQuery(this).remove();
                        });
                    }
                });
            }, 500);
        }
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/services/diyfminsertprogress.js
 ** module id = 941
 ** module chunks = 0
 **/